import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { differenceInCalendarDays } from 'date-fns';
import { NzTreeNode, NzTreeNodeOptions } from 'ng-zorro-antd';
import { PromptService } from 'src/app/services/prompt.service';
import { spaceValidator } from './validator';
declare const $;
declare function setMaxDigits(v: number): void;
declare class RSAKeyPair {
  constructor(e: string, d: string, m: string, len?: number);
};
declare function encryptedString(key: RSAKeyPair, data: string): string;

interface checkboxOptions {
  label: string,
  value: string,
  checked: Boolean
}

/**
 * 表单项
 */
export interface KFormItem {
  //是否显示红色*号(无需填写,根据validator获得值)
  required?: boolean,
  //控件类型 复选框|树选择|多行文本框|日期选择框|普通输入框|单选框|可勾选选择框
  controlType?: 'multipleselect' | 'treeselect' | 'textarea' | 'date' | 'datetime' | 'daterange' | 'input' | 'select' | 'checkselect' | 'radio' | 'tagsselect' | 'checkboxGroup' | 'numberinput',
  //label名称
  label?: string,
  //表单项名称
  formControlName?: string,
  //禁用组件
  disabled?: boolean,
  //最小值（数字）
  min?: number
  //最大值（数字）
  max?: number
  // 格式化(formatter和parser一般搭配使用)
  formatter?: (value: number | string) => string | number
  // 转换
  parser?: (value: string) => string | number
  //输入框类型
  inputType?: 'text' | 'number' | 'password',
  //选择框项列表
  selectOptions?: Array<
    {
      label: string,
      value: string | number
    }
  > | Array<NzTreeNode | NzTreeNodeOptions>
  checkOptions?: Array<{
    label: string,
    value: string,
    checked: Boolean,
    action?:string,
    method?:string,
    service?:string
  }>,
  selectChange?: Function,
  //默认提示
  placeholder?: string,
  //默认值
  defaultvalue?: any,
  //值
  value?: any,
  //错误提示
  errorList?: Array<
    {
      key: string,
      tip: string
    }>,
  //验证规则
  validator?: Array<any>
  //数据处理
  datadeal?: Function
  treeshow?: Function
}

/**
 * 表单实体id接口
 */
export interface FormEntityId<T> {
  Id: T;
}

@Component({
  selector: 'kform',
  templateUrl: './kform.component.html',
  styleUrls: ['./kform.component.less']
})
export class KformComponent {

  //表单配置项
  private _formItems: Array<KFormItem> = [];
  @Input()
  set formItems(items: Array<KFormItem>) {
    if (items == null)
      return;
    this._formItems = items;
    this.setForm();
  }
  get formItems(): Array<KFormItem> {
    this.updateFormValidators();
    return this._formItems;
  }
  //默认数据
  private _defaultData: any;
  @Input()
  set defaultData(value: any) {
    this._defaultData = value;
    this.setFormData();
  }

  //验证器
  formValidator: {
    [key: string]: any;
  } = {};
  //表单
  formGroup: FormGroup;

  //获取验证状态
  public get valid(): boolean {
    if (this.formGroup == null)
      return false;
    else
      return this.formGroup.valid;
  }


  //更新表单验证
  public updateFormValidators() {
    for (var i in this._formItems) {
      this.formGroup.get(this._formItems[i].formControlName)!.clearValidators();
      this.formGroup.get(this._formItems[i].formControlName)!.setValidators(this._formItems[i].validator);
      this.formGroup.get(this._formItems[i].formControlName)!.updateValueAndValidity();
    }
    let checkPSW = this._formItems.find(p => p.formControlName == "checkpassword");
    if (checkPSW) {
      this.formGroup.get("checkpassword")!.clearValidators();
      this.formGroup.get("checkpassword")!.setValidators(this.confirmValidator);
      this.formGroup.get("checkpassword")!.updateValueAndValidity();
    }
  }

  //表单数据,如果存在默认值的话
  formData: any;
  constructor(private fb: FormBuilder,
    private promptService: PromptService) {
    this.formGroup = this.fb.group({});
  }

  //设置表单
  public setForm() {
    let checkPSW = this._formItems.find(p => p.formControlName == "checkpassword");
    if (checkPSW) checkPSW.validator.push(this.confirmValidator);
    for (var i in this._formItems) {
      var formItem = this._formItems[i];
      if ((formItem.controlType == "textarea" || formItem.controlType == "input") && formItem.errorList.find(p => p.key == "space") == null) {
        formItem.errorList.push({ key: "space", tip: "该项前后不能输入空格" });
        formItem.validator.push(spaceValidator);
      }
      formItem.disabled = formItem.disabled == undefined ? false : formItem.disabled;
      if (formItem.selectChange == null)
        formItem.selectChange = () => { };
      this.formValidator[formItem.formControlName]
        = new FormControl({
          value: formItem.value,
          disabled: formItem.disabled
        }, formItem.validator);
    }
    //设置表单验证器
    this.formGroup = this.fb.group(this.formValidator);
  }



  //设置表单默认值
  private setFormData() {
    this.formData = {};
    for (var i in this._formItems) {
      var formItem = this._formItems[i];
      if (this._defaultData != null
        && this._defaultData.hasOwnProperty(formItem.formControlName)) {
        formItem.value = this._defaultData[formItem.formControlName];
        this.formData[formItem.formControlName] = formItem.value;
      } else {
        formItem.value = null;
        if (formItem.defaultvalue != undefined) {
          formItem.value = formItem.defaultvalue;
          this.formData[formItem.formControlName] = formItem.defaultvalue;
        } else {
          this.formData[formItem.formControlName] = null;
        }
      }
    }
    this.formGroup.setValue(this.formData);
  }

  /**
 * 加密方法
 */
  public key() {
    let RSA = JSON.parse(localStorage.getItem("RSA"))
    var m = RSA.Modulus;
    var e = RSA.Exponent;
    setMaxDigits(130);
    // 第一个参数是加密因子，第二个参数是解密因子
    // 因为浏览器端不需要解密，所以第二个参数传入空字符串
    return new RSAKeyPair(e, "", m);
  };


  //提交表单
  public submitForm(): any {
    for (const key in this.formGroup.controls) {
      this.formGroup.controls[key].markAsDirty();
      this.formGroup.controls[key].updateValueAndValidity();
    }
    if (this.formGroup.invalid) {
      this.promptService.warning("填写的数据有误，请检查标红字段").subscribe();
      return;
    }
    let formValue = this.formGroup.value;
    // if (formValue["password"]) {
    //   formValue["password"] = encryptedString(this.key(), formValue["password"])
    // }
    return this.formGroup.value;

  }

  //进行密码重复验证
  public doValidity(name): any {
    if (name == "checkpassword") {
      this.formGroup.get('checkpassword')!.setValidators(this.confirmValidator);
      if (this.formGroup.controls["checkpassword"].value != null) {
        this.formGroup.controls["checkpassword"].markAsDirty();
        this.formGroup.controls["checkpassword"].updateValueAndValidity();
      }
    }
    if (name == "password") {
      this.formGroup.get('checkpassword')!.setValidators(this.confirmValidator);
      if (this.formGroup.controls["checkpassword"].value != null) {
        this.formGroup.controls["checkpassword"].markAsDirty();
        this.formGroup.controls["checkpassword"].updateValueAndValidity();
      }
    }
  }

  //日期处理 不大于9999-12-31
  disabledDate = (current: Date): boolean => {
    const Maxday = new Date("9999-12-31");
    return differenceInCalendarDays(current, Maxday) > 0;
  };


  //重置表单
  resetForm(): void {
    this.formGroup.reset();
    for (const key in this.formGroup.controls) {
      this.formGroup.controls[key].markAsPristine();
      this.formGroup.controls[key].updateValueAndValidity();
    }
  }

  //重复密码验证
  public confirmValidator = (control: FormControl) => {
    if (!control.value) {
      return null;
    } else if (control.value != this.formValidator["password"].value) {
      return { checkpsw: true };
    }
    return null;
  };
}
